import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { CalendarCheck, MapTrifold, User, SignOut, Receipt } from "@phosphor-icons/react";
import { useAuth } from "../../context/AuthContext";
import Logo from "../../components/Logo";
import { GetAppButton } from "../../components/InstallGuide";

export default function MemberLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => { await logout(); navigate("/", { replace: true }); };

  const items = [
    { to: "/member", end: true, icon: <CalendarCheck size={18} weight="duotone" />, label: "My classes" },
    { to: "/member/discover", icon: <MapTrifold size={18} weight="duotone" />, label: "Discover" },
    { to: "/member/receipts", icon: <Receipt size={18} weight="duotone" />, label: "Receipts" },
    { to: "/member/profile", icon: <User size={18} weight="duotone" />, label: "Profile" },
  ];

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid="member-layout">
      <header className="border-b border-white/10 sticky top-0 z-40 bg-[#0A0A0A]/95 backdrop-blur">
        <div className="max-w-[1100px] mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <Logo size={28} />
            <div>
              <div className="font-display text-xl leading-none uppercase">TRAINA</div>
              <div className="tracker text-zinc-500 mt-1 hidden md:block">Book classes anywhere</div>
            </div>
          </div>
          <div className="flex items-center gap-3 sm:gap-4">
            <div className="text-right hidden sm:block">
              <div className="text-sm font-semibold" data-testid="member-name">{user?.name}</div>
              <div className="tracker">{user?.email}</div>
            </div>
            <button onClick={onLogout} className="btn-ghost !py-2 !px-3" data-testid="member-logout">
              <SignOut size={16} weight="bold" />
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-[1100px] mx-auto min-w-0">
        <div className="border-b border-white/10">
          <div className="flex overflow-x-auto min-w-0">
            {items.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-6 py-4 tracker whitespace-nowrap ${isActive ? "text-white border-b-2 border-brand" : "text-zinc-400 hover:text-white"}`
                }
                data-testid={`member-nav-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {it.icon} {it.label}
              </NavLink>
            ))}
            <GetAppButton className="!w-auto whitespace-nowrap !px-6 !py-4" />
          </div>
        </div>
        <main className="p-4 sm:p-6 lg:p-10 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
